import BlogLayout from "./js/layouts/landing/BlogLayout";
import BlogPostShareModal from "./js/modules/blog/components/BlogPostShareModal";

export default {
   BlogLayout,
   BlogPostShareModal
}; 